"use client";

import { useEffect } from "react";
import { ErrorFallback } from "@/components/ErrorFallback";
import { isDOMManipulationError, reportDOMErrorToDatadog } from "@/utils/errorReporting";

/**
 * Error boundary for public pages.
 * Catches runtime errors and provides a recovery UI.
 */
export default function PublicError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (isDOMManipulationError(error)) {
      reportDOMErrorToDatadog(error, "public");
    } else {
      console.error("Public page error:", error);
    }
  }, [error]);

  return <ErrorFallback onReset={reset} />;
}
